import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { WithTheme } from './../../../setup/index'

export const ElasticCarouselStyled = styled.div`
  .rec-carousel-wrapper {
    padding-top: 40px;
  }
  .rec-carousel {
    position: relative;
  }
  .rec-arrow {
    position: absolute;
    top: -40px;
  }
  .rec-arrow-next {
    ${({ theme }) =>
      theme.direction === 'rtl'
        ? css`
            right: 40px;
            transform: rotate(180deg);
          `
        : css`
            right: 0;
          `}
  }
  .rec-arrow-prev {
    right: 40px;
    ${({ theme }) =>
      theme.direction === 'rtl'
        ? css`
            right: 0;
            transform: rotate(180deg);
          `
        : css`
            right: 40px;
          `}
  }
  .rec-slider-container {
    margin: 0;
  }

  ${({ isAlt, theme }) =>
    isAlt &&
    css`
      .rec-carousel-wrapper {
        padding-top: 0;
      }
      .rec-arrow {
        position: static;
      }
      .rec-arrow-next {
        ${theme.direction === 'rtl' ? 'transform: none' : ''}
      }
      .rec-arrow-prev {
        ${theme.direction === 'rtl' ? 'transform: none' : ``}
      }
    `}
`

export const ArrowContainerStyled = styled.div<WithTheme>`
  color: ${({ theme }) => theme.colors.green};
  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0;
      pointer-events: none;
    `}
`
